import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { computed } from "vue";
import { Image, Page, Text, View } from "@ceereals/vue-pdf";
import { formatPdfCurrency, formatPdfShortDate, formatPdfTime, getEndDatetime, getStartDatetime, } from "./itinerary-pdf-formatters";
import { createItineraryPdfStyles } from "./styles";
import { formatPhoneNumberForDisplay } from "@/shared/utils/phone-number";
import { toIntlLocale, translatePdf } from "./pdf-i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CoverPage',
    props: {
        projection: {}
    },
    setup(__props) {
        const props = __props;
        const locale = computed(() => props.projection.locale);
        function t(key, named) {
            return translatePdf(locale.value, key, named);
        }
        const styles = computed(() => createItineraryPdfStyles(props.projection.theme).coverStyles);
        const itinerary = computed(() => props.projection.itinerary);
        const customer = computed(() => itinerary.value.customer ?? {});
        const concierge = computed(() => props.projection.concierge);
        const conciergePhone = computed(() => formatPhoneNumberForDisplay(concierge.value?.contact_phone));
        const customerPhone = computed(() => formatPhoneNumberForDisplay(customer.value.whatsapp_phone || customer.value.phone));
        const brandName = computed(() => props.projection.brand?.name ||
            concierge.value?.company_name ||
            concierge.value?.assigned_person ||
            concierge.value?.name ||
            "Emanta");
        const brandLogoUrl = computed(() => props.projection.brand?.logoUrl || concierge.value?.image_url || null);
        const services = computed(() => itinerary.value.slots_itineraries ?? []);
        const today = computed(() => new Date().toLocaleDateString(toIntlLocale(locale.value), {
            day: "numeric",
            month: "long",
            year: "numeric",
            timeZone: "America/Costa_Rica",
        }));
        const documentTitle = computed(() => props.projection.brand?.documentTitle || t("pdf.cover.default_title"));
        const serviceCountLabel = computed(() => t(services.value.length === 1
            ? "pdf.cover.service_count_singular"
            : "pdf.cover.service_count_plural", { count: services.value.length }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Page), {
                size: "A4",
                style: _normalizeStyle(styles.value.page)
            }, {
                default: _withCtx(() => [
                    _createVNode(_unref(View), {
                        style: _normalizeStyle(styles.value.heroSection)
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(View), {
                                style: _normalizeStyle(styles.value.accentBar)
                            }, null, 8, ["style"]),
                            _createVNode(_unref(View), {
                                style: _normalizeStyle(styles.value.logoContainer)
                            }, {
                                default: _withCtx(() => [
                                    (brandLogoUrl.value)
                                        ? (_openBlock(), _createBlock(_unref(Image), {
                                            key: 0,
                                            src: brandLogoUrl.value,
                                            style: _normalizeStyle(styles.value.logo)
                                        }, null, 8, ["src", "style"]))
                                        : _createCommentVNode("", true),
                                    _createVNode(_unref(View), {
                                        style: _normalizeStyle(styles.value.companyInfo)
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Text), {
                                                style: _normalizeStyle(styles.value.companyName)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(brandName.value), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["style"]),
                                            (conciergePhone.value)
                                                ? (_openBlock(), _createBlock(_unref(Text), {
                                                    key: 0,
                                                    style: _normalizeStyle(styles.value.companyContact)
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(t("pdf.cover.tel_prefix")) + " " + _toDisplayString(conciergePhone.value), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            (concierge.value?.email)
                                                ? (_openBlock(), _createBlock(_unref(Text), {
                                                    key: 1,
                                                    style: _normalizeStyle(styles.value.companyContact)
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(concierge.value.email), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    }, 8, ["style"])
                                ]),
                                _: 1
                            }, 8, ["style"]),
                            _createVNode(_unref(Text), {
                                style: _normalizeStyle(styles.value.heroTitle)
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(documentTitle.value), 1)
                                ]),
                                _: 1
                            }, 8, ["style"]),
                            _createVNode(_unref(Text), {
                                style: _normalizeStyle(styles.value.heroSubtitle)
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(itinerary.value.code || t("pdf.cover.reference_unavailable")) + " | " + _toDisplayString(t("pdf.cover.created_on")) + " " + _toDisplayString(today.value), 1)
                                ]),
                                _: 1
                            }, 8, ["style"])
                        ]),
                        _: 1
                    }, 8, ["style"]),
                    _createVNode(_unref(View), {
                        style: _normalizeStyle(styles.value.contentSection)
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(View), {
                                style: _normalizeStyle(styles.value.customerCard)
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(Text), {
                                        style: _normalizeStyle(styles.value.sectionTitle)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(t("pdf.cover.customer_info")), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["style"]),
                                    _createVNode(_unref(Text), {
                                        style: _normalizeStyle(styles.value.customerName)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(customer.value.name || "") + " " + _toDisplayString(customer.value.last_name || ""), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["style"]),
                                    _createVNode(_unref(View), {
                                        style: _normalizeStyle(styles.value.customerDetails)
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(View), {
                                                style: _normalizeStyle(styles.value.customerDetailItem)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(Text), {
                                                        style: _normalizeStyle(styles.value.detailLabel)
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(t("pdf.cover.identification")), 1)
                                                        ]),
                                                        _: 1
                                                    }, 8, ["style"]),
                                                    _createVNode(_unref(Text), {
                                                        style: _normalizeStyle(styles.value.detailValue)
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(customer.value.dni || "-"), 1)
                                                        ]),
                                                        _: 1
                                                    }, 8, ["style"])
                                                ]),
                                                _: 1
                                            }, 8, ["style"]),
                                            _createVNode(_unref(View), {
                                                style: _normalizeStyle(styles.value.customerDetailItem)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(Text), {
                                                        style: _normalizeStyle(styles.value.detailLabel)
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(t("pdf.cover.phone")), 1)
                                                        ]),
                                                        _: 1
                                                    }, 8, ["style"]),
                                                    _createVNode(_unref(Text), {
                                                        style: _normalizeStyle(styles.value.detailValue)
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(customerPhone.value || "-"), 1)
                                                        ]),
                                                        _: 1
                                                    }, 8, ["style"])
                                                ]),
                                                _: 1
                                            }, 8, ["style"]),
                                            _createVNode(_unref(View), {
                                                style: _normalizeStyle(styles.value.customerDetailItem)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(Text), {
                                                        style: _normalizeStyle(styles.value.detailLabel)
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(t("pdf.cover.email")), 1)
                                                        ]),
                                                        _: 1
                                                    }, 8, ["style"]),
                                                    _createVNode(_unref(Text), {
                                                        style: _normalizeStyle(styles.value.detailValue)
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(customer.value.email || "-"), 1)
                                                        ]),
                                                        _: 1
                                                    }, 8, ["style"])
                                                ]),
                                                _: 1
                                            }, 8, ["style"]),
                                            _createVNode(_unref(View), {
                                                style: _normalizeStyle(styles.value.customerDetailItem)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(Text), {
                                                        style: _normalizeStyle(styles.value.detailLabel)
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(t("pdf.cover.country")), 1)
                                                        ]),
                                                        _: 1
                                                    }, 8, ["style"]),
                                                    _createVNode(_unref(Text), {
                                                        style: _normalizeStyle(styles.value.detailValue)
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(customer.value.country || "-"), 1)
                                                        ]),
                                                        _: 1
                                                    }, 8, ["style"])
                                                ]),
                                                _: 1
                                            }, 8, ["style"])
                                        ]),
                                        _: 1
                                    }, 8, ["style"])
                                ]),
                                _: 1
                            }, 8, ["style"]),
                            _createVNode(_unref(View), {
                                style: _normalizeStyle(styles.value.tripSummarySection)
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(View), {
                                        style: _normalizeStyle(styles.value.tripSummaryHeader)
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Text), {
                                                style: _normalizeStyle(styles.value.tripSummaryTitle)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(t("pdf.cover.trip_summary")), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["style"]),
                                            _createVNode(_unref(Text), {
                                                style: _normalizeStyle(styles.value.serviceCount)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(serviceCountLabel.value), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["style"])
                                        ]),
                                        _: 1
                                    }, 8, ["style"]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (item, index) => {
                                        return (_openBlock(), _createBlock(_unref(View), {
                                            key: item.id ?? index,
                                            style: _normalizeStyle(styles.value.serviceSummaryItem)
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(View), {
                                                    style: _normalizeStyle(styles.value.serviceIndex)
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(Text), {
                                                            style: _normalizeStyle(styles.value.serviceIndexText)
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(index + 1), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["style"])
                                                    ]),
                                                    _: 2
                                                }, 1032, ["style"]),
                                                _createVNode(_unref(View), {
                                                    style: _normalizeStyle(styles.value.serviceSummaryContent)
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(Text), {
                                                            style: _normalizeStyle(styles.value.serviceSummaryName)
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(item.service?.name || t("pdf.common.service_fallback")), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["style"]),
                                                        _createVNode(_unref(Text), {
                                                            style: _normalizeStyle(styles.value.serviceSummaryDetails)
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_unref(formatPdfShortDate)(_unref(getStartDatetime)(item), locale.value)) + " | " + _toDisplayString(_unref(formatPdfTime)(_unref(getStartDatetime)(item), locale.value)) + " - " + _toDisplayString(_unref(formatPdfTime)(_unref(getEndDatetime)(item), locale.value)), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["style"])
                                                    ]),
                                                    _: 2
                                                }, 1032, ["style"]),
                                                _createVNode(_unref(Text), {
                                                    style: _normalizeStyle(styles.value.serviceSummaryPrice)
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(formatPdfCurrency)(item.total ?? item.total_amount)), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["style"])
                                            ]),
                                            _: 2
                                        }, 1032, ["style"]));
                                    }), 128))
                                ]),
                                _: 1
                            }, 8, ["style"])
                        ]),
                        _: 1
                    }, 8, ["style"]),
                    _createVNode(_unref(View), {
                        style: _normalizeStyle(styles.value.footer),
                        fixed: ""
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(Text), {
                                style: _normalizeStyle(styles.value.footerBranding)
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(brandName.value), 1)
                                ]),
                                _: 1
                            }, 8, ["style"]),
                            _createVNode(_unref(Text), {
                                style: _normalizeStyle(styles.value.footerDate)
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(today.value), 1)
                                ]),
                                _: 1
                            }, 8, ["style"])
                        ]),
                        _: 1
                    }, 8, ["style"])
                ]),
                _: 1
            }, 8, ["style"]));
        };
    }
});
